import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [{
        path: '/',
        name: 'home',
        component: () => import('../views/home/index.vue'),
    },
    {
        path: '/list',
        name: 'list',
        component: () => import('../views/list/index.vue'),
    },
    {
        path: '/list-details',
        name: 'list-details',
        component: () => import('../views/list-details/index.vue'),  
    },
    {
        path: '/introduction',
        name: 'introduction',
        component: () => import('../views/introduction/index.vue'),  
    },
    {
        path: '/unified-assessment',
        name: 'unified-assessment',
        component: () => import('../views/unified_assessment/index.vue'),  
    },
    {
        path: '/suggest',
        name: 'suggest',
        component: () => import('../views/suggest/index.vue'),  
    }
];

// 路由配置
const RouterConfig = {
    routes,
};

export const router = new VueRouter(RouterConfig);
